// cache.js
import { InMemoryCache } from '@apollo/client/core';

// Use a FIXED string. Never change this.
export const authStatusId = 'local-auth-status';

// Function to create cache with optional persistence for "Remember Me" users
export function createCache() {
    // Check if user has chosen "Remember Me" (has remembered credentials)
    const rememberedEmail = localStorage.getItem('rememberedEmail');
    const rememberedPassword = localStorage.getItem('rememberedPassword');

    // If user chose "Remember Me", try to restore cache from localStorage
    if (rememberedEmail && rememberedPassword) {
        try {
            const persistedCache = localStorage.getItem('apollo-cache-persistence');
            if (persistedCache) {
                const cacheData = JSON.parse(persistedCache);
                // Use the same complete type policies as the default cache
                return new InMemoryCache({
                    typePolicies: {
                        AuthStatus: {
                            keyFields: ["ID"],
                        },
                        Queries:{
                            keyFields: ["ID"],
                        },
                        Branch:{
                            keyFields: ["ID"],
                        },
                        Nod:{
                            keyFields: ["ID"]
                        },
                        clientInstanceRequest:{
                            keyFields: ["ID"],
                        },
                        tempInstance:{
                            keyFields: ["ID"],
                        },
                        Instance:{
                            keyFields: ["ID"],
                        },
                        Cluster: {
                            keyFields:     ["ID"],
                        },
                        Collection: {
                            keyFields: ["ID"],
                            merge(existing, incoming) {
                                const existingArray = Array.isArray(existing) ? existing : [];
                                return [...existingArray, incoming];
                            },
                        },
                        modalVars:{
                            merge: false
                        },
                        iCollection:{
                            keyFields:     ["ID"],
                        },
                        iCollections:{
                            keyArgs: ["root", "applyFilters", "group", "skip", "limit"],
                            merge: false
                        },
                        Tree:{
                            keyFields: ["ID"],
                            fields:{
                                ClientBranch:{
                                    merge:true
                                }
                            }
                        },
                        ClientBranch: {
                            keyFields: ["ID"],
                            merge: false,
                        },
                        ITrees:{
                            keyFields:  ["ID"],
                            fields:{
                                ITree:{
                                    merge(incoming) {
                                        return incoming
                                    }
                                }
                            }
                        },
                        ITree:{
                            keyFields:  ["ID"],
                        },
                        iBranch:{
                            keyFields: ["ID"],
                        },
                        ClientInstance:{
                            keyFields: ["ID"],
                            fields:{
                                ClientBranch:{
                                    merge(existing,incoming){return incoming}
                                }
                            },
                        },
                    }
                }).restore(cacheData);
            }
        } catch (error) {
            console.warn('Failed to restore Apollo cache:', error);
        }
    }

    // Default cache for users who didn't choose "Remember Me"
    const defaultCache = new InMemoryCache({
        typePolicies: {
            // Define type policies for AuthStatus if needed, e.g., keyFields
            AuthStatus: {
                keyFields: ["ID"], // Tell Apollo how to uniquely identify AuthStatus objects
            },
            Queries:{
                keyFields: ["ID"],
            },
            Branch:{
                keyFields: ["ID"],
            },
            Nod:{
                keyFields: ["ID"]
            },
            clientInstanceRequest:{
                keyFields: ["ID"],
            },
            tempInstance:{
                keyFields: ["ID"],
            },
            Instance:{
                keyFields: ["ID"],
            },
            Cluster: {
                keyFields:     ["ID"],
            },
            Collection: {
                keyFields: ["ID"],
                merge(existing, incoming) {
                    const existingArray = Array.isArray(existing) ? existing : [];
                    return [...existingArray, incoming];
                },
            },
            modalVars:{
                merge: false
            },
            iCollection:{
                keyFields: ["ID"],
            },
            iCollections:{
                keyArgs: ["root", "applyFilters", "group", "skip", "limit"],
                merge: false
            },
            Tree:{
                keyFields: ["ID"],
                fields:{
                    ClientBranch:{
                        merge:true
                    }
                }
            },

            ClientBranch: {
                keyFields: ["ID"],
                merge: false,
            },
            // Remove computed path; path will be explicitly written/updated by app logic

            ITrees:{
                keyFields:  ["ID"],
                fields:{
                    ITree:{
                        merge(incoming) {
                            return incoming
                        }
                    }
                }
            },
            ITree:{
                keyFields:  ["ID"],
            },
            iBranch:{
                keyFields: ["ID"],
            },
            ClientInstance:{
                keyFields: ["ID"],
                fields:{
                    ClientBranch:{
                        merge(existing,incoming){return incoming}
                    }
                },
            },
        }
    });

    return defaultCache;
}
